export default __webpack_public_path__ + "static/media/bench.6907c63f.svg";